module.exports = __webpack_public_path__ + "1a525cbd2dc4a7e6f04f15d843995819.MP3";